export const STATUS_LABEL = {
  belum: { label: "Belum Dikerjakan", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  dikerjakan: { label: "Dikerjakan", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  dikumpulkan: { label: "Dikumpulkan", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  dianalisis: { label: "Dianalisis AI", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  menunggu_review: { label: "Menunggu Review Guru", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  dinilai: { label: "Dinilai", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  revisi: { label: "Perlu Revisi", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  terlambat: { label: "Terlambat", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const ATT_STATUS = {
  menunggu: { label: "Menunggu", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  hadir: { label: "Hadir", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  izin: { label: "Izin", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  sakit: { label: "Sakit", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  ditolak: { label: "Ditolak", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  alpa: { label: "Alpa", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const TYPE_LABEL = {
  online: "Tugas Online",
  catatan: "Tugas Catatan",
  latihan: "Tugas Latihan",
  pr: "PR / Tugas Rumah",
  tatap_muka: "Tugas Tatap Muka",
};

export const KELAS_LABEL = (k) => `Kelas ${k}`;
